export const PRIMARY_DOMAIN = 'tonglian.chat';

export const DEFAULT_API_BASE_URL = `https://fzapi.${PRIMARY_DOMAIN}`;
